import { FOURTH_GIG_PACKAGE } from '../experimentsEnum';
import { inAbTest } from '..';

export default (abTests) => inAbTest(abTests, FOURTH_GIG_PACKAGE);
